import './minimized-header.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleQuestion } from '@fortawesome/free-solid-svg-icons';
import logoWhite from '../../../assets/images/svg/logo-white.svg';

export const MinimizedHeader = () => {
	/* methods */
	const onHelpButtonClicked = () => {
		window.open('https://healthbegins.org/partnership-resources/', '_blank');
	};

	const onContactUsClickedHandler = () => {
		window.open(
			'https://share.hsforms.com/10wbTH1l5Q166QSkjpbS1Yw5ln95',
			'_blank',
		);
	};

	const navigateToWelcomePage = () => {
		window.open('https://healthbegins.org/', '_blank');
	};

	return (
		<header className='w-full bg-primary text-white shadow-soft'>
			<div className='flex items-center justify-between gap-[2rem] px-[4rem] py-[1.6rem] sm:px-[1.6rem] xs:px-[1.6rem]'>
				<div
					className='flex items-center gap-[1.4rem] cursor-pointer'
					onClick={navigateToWelcomePage}
				>
					<img
						src={logoWhite}
						alt='HealthBegins'
						className='h-[3.4rem] w-auto shrink-0'
					/>
					<div className='h-[2.8rem] w-px bg-white/25 sm:hidden xs:hidden'></div>
					<div className='font-montserrat text-[1.9rem] font-normal leading-tight text-white sm:hidden xs:hidden'>
						Return on investment calculator
					</div>
				</div>
				<div className='flex items-center gap-[1.2rem]'>
					<button
						onClick={onHelpButtonClicked}
						className='flex items-center gap-[0.7rem] rounded-full border border-white/40 px-[1.8rem] py-[0.9rem] font-colfax text-[1.5rem] text-white transition-colors duration-200 hover:bg-white/10'
					>
						<FontAwesomeIcon
							icon={faCircleQuestion}
							className='h-[1.6rem] w-[1.6rem]'
						/>
						Help
					</button>
					<button
						onClick={onContactUsClickedHandler}
						className='rounded-full bg-secondary px-[1.9rem] py-[1rem] font-colfax text-[1.5rem] text-white shadow-soft transition-all duration-200 ease-out hover:-translate-y-[0.1rem] hover:bg-secondary-600 hover:shadow-card'
					>
						Contact us
					</button>
				</div>
			</div>
		</header>
	);
};
